import { makeStyles } from "tss-react/mui";

export const useStyle = makeStyles()(() => ({
    link: {
        cursor: "pointer",
    },
}));
